module.exports = __webpack_public_path__ + "fontoctopus.af93096ee4f17f3ce6d6363747b45e97.hashedasset.eot";


//////////////////
// WEBPACK FOOTER
// ./app/resources/fonts/fontoctopus/fontoctopus.eot
// module id = 235
// module chunks = 8